import { Button } from "@web/components/ui/button";
import { useLanguage } from "@web/lib/contexts/language-context";
import { motion } from "framer-motion";
import { X } from "lucide-react";
import { useNavigate } from "react-router";

type CameraError = {
	isUsingQueryEntry: boolean;
	retakePhoto: () => void;
	activeError: unknown;
};

export const CameraError = (props: CameraError) => {
	const navigate = useNavigate();
	const { isUsingQueryEntry, retakePhoto, activeError } = props;
	const { t } = useLanguage();

	return (
		<motion.div className="fixed inset-0 flex flex-col items-center justify-center bg-black p-6">
			<div className="w-full max-w-md rounded-lg bg-red-50 p-6 text-red-800">
				<div className="flex items-center">
					<X className="mr-2 h-6 w-6" />
					<p className="text-lg font-medium">
						{isUsingQueryEntry
							? t.camera.errorValidatingSeal
							: t.camera.errorSendingPhoto}
					</p>
				</div>
				<p className="mt-2">
					{activeError &&
					typeof activeError === "object" &&
					"data" in activeError &&
					activeError.data &&
					typeof activeError.data === "object" &&
					"message" in activeError.data
						? activeError.data.message
						: isUsingQueryEntry
							? t.camera.errorValidatingSealDescription
							: t.camera.errorProcessingImage}
				</p>
				<div className="mt-4 flex gap-3">
					<Button
						variant="outline"
						className="border-red-300 text-red-800 hover:bg-red-100 bg-transparent"
						onClick={retakePhoto}
					>
						{t.common.retry}
					</Button>
					<Button onClick={() => navigate(-1)}>{t.common.back}</Button>
				</div>
			</div>
		</motion.div>
	);
};
